export default "__VITE_ASSET__f7f0046a__"